import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY } from 'rxjs';
import { OpenerWatchdogService } from '../../../../attachments-handler/src/lib/services/opener-watchdog.service';

export const openerCheckInterceptor: HttpInterceptorFn = (req, next) => {
    const watchdog = inject(OpenerWatchdogService);
    watchdog.check();
    if (watchdog.isParentClosed()) {
        return EMPTY;
    }
    return next(req);
};
